import React from "react";
import { ImagePictureAddPlusIcon } from "@/shared/icons/ImagePictureAddPlusIcon";
import { VideoPlaceHolderIcon } from "@/shared/icons/VideoPlaceHolderIcon";
import { CodeTextIcon } from "@/shared/icons/CodeTextIcon";
import { ElementType } from "@/shared/types";

const ElementPlaceholderIcon = {
  [ElementType.Image]: ImagePictureAddPlusIcon,
  [ElementType.Video]: VideoPlaceHolderIcon,
  [ElementType.Embed]: CodeTextIcon,
};

export const ElementPlaceholder = ({
  elementType,
}: {
  elementType: ElementType;
}) => {
  const Component = ElementPlaceholderIcon[elementType];

  if (!Component) return null;

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: "6px",
        border: "1px solid",
        borderColor: "#D0D5DD",
        backgroundColor: "#F2F4F7",
        boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
      }}
    >
      <div
        style={{
          padding: "8px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "100%",
          border: "1px solid",
          borderColor: "#D0D5DD",
          backgroundColor: "#FFFFFF",
          boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
        }}
      >
        <Component size="20px" />
      </div>
    </div>
  );
};
